export const mapPropertyFromStore = (store) => (name) => (obj) => {
  let {getter, action, mutation} = (typeof obj === 'object' ? obj : {getter: obj})
  return {
    [name]: {
      get() {
        return store.getters[getter]
      },
      set(newValue) {
        action ? store.dispatch(action, newValue)
          : (mutation ? store.commit(mutation, newValue)
          : undefined)
      }
    }
  }
};

export const mapPropertiesFromStore = (store) => (obj) => {
  let mapProperty = mapPropertyFromStore(store);
  return Object.keys(obj)
    .reduce((acc, key) => Object.assign(acc, mapProperty(key)(obj[key])), {})
};
